import { Injectable } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-common';
import { environment } from '@env';
import { HOME_URL, LOGIN_URL } from '@constants/url.constant';

import { Observable, firstValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Util } from '@utils/utils';
import _ from 'lodash';

import { ClienteService } from './cliente.service';

import { ModalCierreSesionComponent } from '@components/modal-cierre-sesion/modal-cierre-sesion.component';
import { StorageService } from '@services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  sesionTimestamp: number = null; // para establecer el tiempo de sesion
  alertaSesionTimestamp: number = null; // para establecer el tiempo de alerta de cierre sesion
  modalAlertaSesionPresente: boolean = false;
  authInterval = null; // para verificar cada cierto tiempo la sesion
  refreshTokenInterval = null; // para actualizar el access token
  sesionExpirada: boolean = false;
  modal: any = null;

  accestoken: any = null;
  public user: string = '';
  isQA: boolean = false;
  userQA: object = null;

  constructor(
    private readonly msalSrvs: MsalService,
    private readonly navCtrl: NavController,
    private readonly http: HttpClient,
    private readonly util: Util,
    private readonly clienteSrvs: ClienteService,
    public readonly modalController: ModalController,
    private readonly StorageSrvs: StorageService,
  ) {
    if (this.isLoggedIn() || this.isQA) {
      this.activaControldeSesion();
      if (this.isLoggedIn()) {
        this.refreshTokenMsal();
      }
      this.user = this.getUsername();
    }
  }

  isLoggedIn(): boolean {
    return this.msalSrvs.instance.getActiveAccount() !== null;
  }

  login() {
    this.userQA = null;
    this.msalSrvs.loginPopup().subscribe((response: AuthenticationResult) => {
      this.StorageSrvs.sesionSet(
        response.uniqueId + '.' + response.tenantId + '-acct',
        response.accessToken,
      );
      this.sesionExpirada = false;
      this.activaControldeSesion();
      this.msalSrvs.instance.setActiveAccount(response.account);
      this.user = this.getUsername();
      this.refreshTokenMsal();
      this.navCtrl.navigateRoot(HOME_URL);
      this.sesionlog();
    });
  }

  logout() {
    this.clienteSrvs.cleanBuscar(true);
    this.msalSrvs.instance.setActiveAccount(null);
    this.StorageSrvs.sesionClear();
    clearInterval(this.authInterval);
    clearInterval(this.refreshTokenInterval);
    this.isQA = false;
    this.navCtrl.navigateRoot(LOGIN_URL);
  }

  getName(): string {
    if (this.isQA) {
      return _.get(this.userQA, 'name', 'Usuario QA');
    } else {
      return this.msalSrvs.instance.getActiveAccount().name;
    }
  }
  getUsername(): string {
    if (this.isQA) {
      return _.get(this.userQA, 'username', 'qausuario@sura.cl');
    } else {
      return this.msalSrvs.instance.getActiveAccount().username;
    }
  }

  refreshTokenMsal() {
    let currentAccount = this.msalSrvs.instance.getAccountByUsername(
      this.getUsername(),
    );
    this.msalSrvs.instance
      .acquireTokenSilent({
        scopes: [
          'Directory.ReadWrite.All',
          'openid',
          'Policy.Read.All',
          'Policy.Read.ConditionalAccess',
          'Policy.ReadWrite.ConditionalAccess',
          'profile',
          'User.Invite.All',
          'User.Read.All',
          'User.ReadWrite.All',
        ],
        account: currentAccount,
        forceRefresh: true,
      })
      .then((response) => {
        this.StorageSrvs.sesionSet(
          response.uniqueId + '.' + response.tenantId + '-acct',
          response.accessToken,
        );
      });

    this.refreshTokenInterval = setInterval(
      function () {
        let currentAccount = this.msalSrvs.instance.getAccountByUsername(
          this.getUsername(),
        );
        this.msalSrvs.instance
          .acquireTokenSilent({
            scopes: [
              'Directory.ReadWrite.All',
              'openid',
              'Policy.Read.All',
              'Policy.Read.ConditionalAccess',
              'Policy.ReadWrite.ConditionalAccess',
              'profile',
              'User.Invite.All',
              'User.Read.All',
              'User.ReadWrite.All',
            ],
            account: currentAccount,
            forceRefresh: true,
          })
          .then((response) => {
            this.StorageSrvs.sesionSet(
              response.uniqueId + '.' + response.tenantId + '-acct',
              response.accessToken,
            );
          });
      }.bind(this),
      3600000,
    );
  }

  getSesionBuffer() {
    return this.msalSrvs.instance.getActiveAccount();
  }

  getToken() {
    return this.StorageSrvs.sesionGet(
      this.msalSrvs.instance.getActiveAccount().homeAccountId + '-acct',
    );
  }

  preLogin(token: string): Observable<any> {
    let url = `${environment.BASE_BACKEND}/auth/prelogin`;
    let headers = new HttpHeaders({ token: token });
    let opcions = { headers };
    return this.http.get(url, opcions);
  }

  nuevoTimestampSesion() {
    this.sesionTimestamp = this.util.nuevoTiempoSesion();
    this.alertaSesionTimestamp = this.util.nuevoTiempoAlertaSesion();
  }

  activaControldeSesion() {
    this.nuevoTimestampSesion();
    this.authInterval = setInterval(
      async function () {
        if (this.util.timestampActual() >= this.sesionTimestamp) {
          this.sesionExpirada = true;
          if (this.modal != null) {
            this.modal.dismiss();
          }
          this.logout();
        } else if (this.util.timestampActual() >= this.alertaSesionTimestamp) {
          if (!this.modalAlertaSesionPresente) {
            this.modalAlertaSesionPresente = true;
            this.modal = await this.modalController.create({
              component: ModalCierreSesionComponent,
              cssClass: 'modal-generico',
            });
            await this.modal.present();
            const { data } = await this.modal.onWillDismiss();
            this.modalAlertaSesionPresente = false;
            if (!data) {
              this.logout();
            }
          }
        }
      }.bind(this),
      environment.controlSesion.ciclo_revision,
    );
  }

  public tokenEstimador(rut: string, email: string) {
    let body = { rut: rut, email: email };
    let url = `${environment.BASE_BACKEND}/auth/token`;
    let headers = new HttpHeaders();
    let params = new HttpParams();

    return this.http.post(url, body, { headers, params }) as Observable<any[]>;
  }

  obtenerPerfil() {
    const grupos: any = this.getSesionBuffer().idTokenClaims['groups'];
    if (grupos.includes(environment.SAML_CONFIG.group_ejecutivo2)) {
      return 'Supervisor';
    }
    if (grupos.includes(environment.SAML_CONFIG.group_ejecutivo)) {
      return 'Ejecutivo';
    }
    if (grupos.includes(environment.SAML_CONFIG.group_ejecutivo3)) {
      return 'Ejecutivo Comercial';
    }
    return 'Ejecutivo';
  }

  private sesionlog() {
    let url = `${environment.BASE_BACKEND}/auth/sesion`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    this.http.put(url, {}, { headers, params }).subscribe();
  }

  public obtenerDataSession() {
    return this.msalSrvs.instance.getActiveAccount();
  }
  // --- Obtener perfil extendido desde Microsoft Graph API ---
  public async obtenerPerfilExtendido(): Promise<any> {
    const account = this.msalSrvs.instance.getActiveAccount();

    if (!account) {
      console.warn('No hay cuenta activa para obtener perfil extendido');
      return null;
    }

    try {
      // Usar el token que ya tienes almacenado en lugar de solicitar uno nuevo
      const token = this.getToken();
      if (!token) {
        console.error('❌ No hay token disponible');
        throw new Error('No token available');
      }

      // Llamar a Microsoft Graph API con $select para obtener todos los campos
      const headers = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });

      const graphUrl =
        'https://graph.microsoft.com/v1.0/me?$select=displayName,givenName,surname,userPrincipalName,mail,otherMails,proxyAddresses,jobTitle,mobilePhone,businessPhones,officeLocation,id';
      const perfil = await firstValueFrom(this.http.get(graphUrl, { headers }));

      // Intentar obtener email de múltiples fuentes
      const emailCorporativo =
        perfil['mail'] ||
        (perfil['otherMails'] && perfil['otherMails'].length > 0
          ? perfil['otherMails'][0]
          : null) ||
        perfil['proxyAddresses']
          ?.find((addr) => addr.startsWith('SMTP:'))
          ?.substring(5) ||
        null;

      // Retornar datos combinados: token + Graph API
      return {
        // Datos básicos del token
        username: account.username,
        name: account.name,
        localAccountId: account.localAccountId,
        tenantId: account.tenantId,
        // Datos extendidos de Graph API
        mail: emailCorporativo,
        otherMails: perfil['otherMails'] || [],
        proxyAddresses: perfil['proxyAddresses'] || [],
        userPrincipalName: perfil['userPrincipalName'],
        displayName: perfil['displayName'],
        givenName: perfil['givenName'],
        surname: perfil['surname'],
        jobTitle: perfil['jobTitle'],
        mobilePhone: perfil['mobilePhone'],
        officeLocation: perfil['officeLocation'],
        businessPhones: perfil['businessPhones'],
        id: perfil['id'],
      };
    } catch (error) {
      console.error(
        '❌ Error obteniendo perfil extendido de Graph API:',
        error,
      );
      console.error('Detalles del error:', error);

      // Fallback: retornar solo datos del token
      return {
        username: account.username,
        name: account.name,
        localAccountId: account.localAccountId,
        tenantId: account.tenantId,
        mail: null,
        userPrincipalName: account.username,
      };
    }
  }
  //debo obtener un token de autorizacion  con un nuevo endpoint  con mi variable de entorno WS_BASE_URL+/auth/token
  public async obtenerTokengrabacion(): Promise<string> {
    // Validar que hay una cuenta activa
    const account = this.msalSrvs.instance.getActiveAccount();
    if (!account) {
      console.error('❌ No hay cuenta activa para obtener token de grabación');
      throw new Error('No hay cuenta activa');
    }

    const azureToken = this.getToken();
    if (!azureToken) {
      console.error('❌ No se pudo obtener el token de Azure');
      throw new Error('No se pudo obtener el token de Azure');
    }

    const url = `${environment.WS_BASE_URL}/auth/token`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    //este recibe en  el body un json con el formato {"azure_token": "eyJ0eXAiOiJKV..."}
    const body = { azure_token: azureToken };
    
    try {
      const response = await firstValueFrom(this.http.post(url, body, { headers }));
      //el token de grabacion viene en la propiedad "access_token" del response
      const accessToken = response['access_token'];
      if (!accessToken) {
        console.error('❌ La respuesta no contiene access_token:', response);
        throw new Error('La respuesta no contiene access_token');
      }
      return accessToken;
    } catch (error) {
      console.error('❌ Error obteniendo token de grabación:', error);
      throw error;
    }
  }
  // --- Obtener solo los emails ---
  public async obtenerEmails(): Promise<{
    emailCorporativo: string;
    emailRed: string;
  }> {
    const perfil = await this.obtenerPerfilExtendido();

    return {
      emailCorporativo: perfil?.mail || '',
      emailRed: perfil?.userPrincipalName || perfil?.username || '',
    };
  }
}
